import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from 'app/models/User';
import { AppInjector } from 'app/services/app-injector.service';

@Component({
  selector: 'app-kcs-unknown-tile',
  templateUrl: './kcs-unknown-tile.component.html',
  styleUrls: [
    './kcs-unknown-tile.component.scss',
    '../../kcs-base/kcs-base-common.scss'
  ]
})
export class KcsUnknownTileComponent implements OnInit {
  @Input()
  hit: any;

  @Input()
  indexName: string;

  @Input()
  isFreemium: boolean;

  @Input()
  viewType: string;

  @Output()
  filterClick: EventEmitter<string> = new EventEmitter<string>();

  _userService: User;

  constructor() {
    this._userService = AppInjector.injector.get(User);
  }

  get isEnterprise(): boolean {
    return !this._userService.isAnonymous();
  }

  ngOnInit(): void {}

  onFilterClick(appStore: string) {
    this.filterClick.emit(appStore);
  }
}
